import { useContext, useEffect, useState } from 'react';
import { GContextTypes } from '../types';
import { GlobalContext } from '../contexts';
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography,
} from '@material-ui/core';
import TimelineDoc from '../Sections/shared/TimelineDoc';
import useRequest from '../hooks/useRequest';
import AutoFieldLocal from '../Sections/shared/AutoFieldLocal';
import { procStatus } from '../constants/datatypes';
import { messageAlert } from '../Shared';
import { TextFieldLocal } from '../components';
import PopupSimple from '../pages/main/PopupSimple';
import { covertToDate } from '../Shared/colorFormat';

const PopupDocSteps = ({ open, onClose, row, theme }: any) => {
  const [stepvalue, setStepvalue] = useState<any>(null);
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });
  const [desc, setDesc] = useState('');

  const [saving, setSaving] = useState(false);
  const [steps, setSteps] = useState([]);

  const { editDocStatus } = useRequest();

  const {
    translate: { isRTL, words },
  }: GContextTypes = useContext(GlobalContext);

  useEffect(() => {
    if (row && row._id) {
      setSteps(row?.steps ? JSON.parse(row?.steps) : []);
      const stp = procStatus.find((st: any) => st.id === row?.stepId);
      setStepvalue(stp);
    }
  }, [row, open]);

  const addStep = async () => {
    if (!stepvalue) {
      await messageAlert(
        setAlrt,
        isRTL ? 'يجب اختيار الحالة  ' : 'Document Status Required'
      );
      return;
    }
    setSaving(true);
    const variables: any = {
      docId: row._id,
      stepId: stepvalue.id,
      desc,
    };
    try {
      const res = await editDocStatus({ variables });
      if (res?.data?.updateDocStatus?.ok === true) {
        const data = res?.data?.updateDocStatus?.data;
        if (data) {
          const rowdata = JSON.parse(data);
          setSteps(JSON.parse(rowdata?.steps));
        }
      }
      closeModal();
    } catch (error) {
      setSaving(false);
    }
  };

  const closeModal = () => {
    setStepvalue(null);
    setDesc('');
    setSaving(false);
    setSteps([]);
    onClose();
  };

  return (
    <PopupSimple
      isRTL={isRTL}
      open={open}
      onClose={closeModal}
      title={isRTL ? 'المتابعة' : 'Follow Up'}
      onlyclose
      theme={theme}
      alrt={alrt}
      maxWidth="md"
    >
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Box p={2}>
            <Typography variant="caption">{covertToDate(row?.time)}</Typography>

            <Typography style={{ fontWeight: 'bold', marginTop: 5 }}>
              {isRTL ? 'العميل' : 'Customer'}
            </Typography>
            <Typography>
              {isRTL ? row?.customerNameAr : row?.customerName}
            </Typography>
            <Typography style={{ fontWeight: 'bold', marginTop: 15 }}>
              {isRTL ? 'الموضوع' : 'Description'}
            </Typography>
            <Typography>{row?.desc}</Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <AutoFieldLocal
            Required
            name="procitem"
            title={isRTL ? 'الحالة' : 'Status'}
            words={words}
            options={procStatus}
            value={stepvalue}
            setSelectValue={setStepvalue}
            isRTL={isRTL}
            fullWidth
            mb={0}
          ></AutoFieldLocal>
          <TextFieldLocal
            name="desc"
            label={isRTL ? 'ملاحظات' : 'Notes'}
            value={desc}
            onChange={(e: any) => {
              const value = e.target.value;
              setDesc(value);
            }}
            multiline
            rowsMax={3}
            rows={3}
            fullWidth
            mb={0}
          />
          <Button
            style={{
              width: 100,
              height: 36,
              marginTop: 10,
            }}
            variant="contained"
            onClick={addStep}
            color="primary"
            disabled={saving}
          >
            <Typography
              style={{ marginLeft: 5, marginRight: 5 }}
              variant="subtitle2"
            >
              {isRTL ? 'تحديث' : 'Update'}
            </Typography>
            {saving && (
              <CircularProgress
                style={{ position: 'absolute' }}
                color="primary"
                size={16}
              />
            )}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <TimelineDoc isRTL={isRTL} steps={steps}></TimelineDoc>
        </Grid>
      </Grid>
    </PopupSimple>
  );
};

export default PopupDocSteps;
